import React from 'react';

const FeaturesSection: React.FC = () => {
  return (
    <div id="features" className="bg-white dark:bg-slate-800 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-slate-900 dark:text-slate-50">
            Why Choose Our Signals
          </h2>
          <p className="mt-4 text-lg text-slate-700 dark:text-slate-300">
            Our platform provides you with the tools you need to succeed in cryptocurrency trading.
          </p>
        </div>

        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-lg bg-slate-50 dark:bg-slate-700 p-6 shadow-lg">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary-main text-white">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 dark:text-slate-50">
                Real-time Signals
              </h3>
              <p className="mt-2 text-slate-700 dark:text-slate-300">
                Receive instant notifications for potential trading opportunities across multiple
                cryptocurrencies.
              </p>
            </div>

            <div className="rounded-lg bg-slate-50 dark:bg-slate-700 p-6 shadow-lg">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary-main text-white">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 dark:text-slate-50">
                Advanced Analytics
              </h3>
              <p className="mt-2 text-slate-700 dark:text-slate-300">
                Access detailed market analysis and performance tracking tools to improve your
                trading strategy.
              </p>
            </div>

            <div className="rounded-lg bg-slate-50 dark:bg-slate-700 p-6 shadow-lg">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary-main text-white">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 dark:text-slate-50">
                Secure Platform
              </h3>
              <p className="mt-2 text-slate-700 dark:text-slate-300">
                Trade with confidence knowing your data is protected by enterprise-grade security
                measures.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
